<template>
<div>

    <div style="width:100%; padding-top:200px; height:60px; color:#ffcd00; font-size:30px; text-align:center; line-height:20px;">로그인중..<br>
<span style="font-size:12px;color:#c9c9c9;">잠시만 기다려 주세요. 로그인 처리중입니다.</span>

    </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'home',
  mounted(){
console.log("시작");
              axios.get(this.$parent.persistent.apiUrl + 'loginValidate.php?userUUID=' + this.$route.query.uuid + '&gender=' + this.$route.query.gender)
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(response.data.status == "error"){
              this.$parent.alert(response.data.reason)
            } else {
                this.$parent.loginID = response.data.userid;
                localStorage.setItem('loginID', response.data.userid);
                console.log("Set the ID to " + response.data.userid);
              this.$parent.fetchMyInfo()
              this.$parent.$router.push(this.$route.query.next)
            }
        }).catch((error) => console.log(error));

  },
data(){
  return {
    items: [],
    modalDesc: {
      item: {},
      buyPrice: ""

    },
    alertModal: "",
    currentPage: 1,
    currentType: "weapon"
  }
}
}
</script>
